import { combineReducers } from 'redux';
import auth from './auth';
import utils from './utils';

const createRootReducer = () =>
  combineReducers({
    auth,
    utils
  });

export default createRootReducer;
